// extracted by mini-css-extract-plugin
export default {"rootContainer":"MainPanel_rootContainer__YNSdR"};